var map = {
	"./again.svg": 123,
	"./background.svg": 398,
	"./dk-flag.svg": 399,
	"./en-flag.svg": 400,
	"./highscore/amateur.svg": 401,
	"./highscore/apprentice.svg": 402,
	"./highscore/empty-star.svg": 403,
	"./highscore/expert.svg": 404,
	"./highscore/full-star.svg": 405,
	"./highscore/grand-master.svg": 406,
	"./highscore/master.svg": 407,
	"./highscore/novice.svg": 408,
	"./icon-back.svg": 409,
	"./icon-cookies.svg": 410,
	"./icon-loading.svg": 411,
	"./icon-next-dark.svg": 412,
	"./icon-next-white.svg": 413,
	"./icon-next.svg": 414,
	"./icon-play.svg": 71,
	"./icon-x.svg": 415,
	"./igen.svg": 124,
	"./logo-cgl-dark.svg": 416,
	"./logo-dd.svg": 70,
	"./newQuiz.svg": 125,
	"./nyquiz.svg": 126
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 397;